import { api } from '../../../services'

const loadAreas = async ({ setAreas }) => {
  await api.get('/areaFiles').then((response) => {
    setAreas(response.data)
  })
}

export { loadAreas }
